<template lang="pug">
#app
  .layout.row.ma-0
    .title {{ title }}
    v-spacer
    .caption(v-if="subTitle")
      v-icon(v-if="icon") {{ icon }}
      |  {{ subTitle }}
    v-btn(flat, v-if="btn", small, @click="btn.click()").pa-0.ma-0 {{ btn.title }}
  v-responsive.white--text
    e-chart(:path-option='computeChartOption', height='500px', width='100%')
</template>

<script>
import _ from 'lodash';
import EChart from '@/components/EChart';

export default {
  components: {
    EChart,
  },
  props: {
    title: String,
    gradient: {
      type: Boolean,
      default: false
    },
    subTitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: 'white'
    },
    iconColor: {
      type: String,
      default: 'success'
    },
    type: String,
    chartColor: Array,
    data: Array,
    xAxis: {
      type: Boolean,
      default: true,
    },
    yAxis: {
      type: Boolean,
      default: true,
    },
    btn: Object,
  },
  data () {
    return {
      defaultOption: [
        ['dataset.source', this.data],
        ['xAxis.show', this.xAxis],
        ['yAxis.show', this.yAxis],
        ['grid.top', '15%'],
        ['grid.left', '10'],
        ['grid.bottom', '10'],
        ['grid.right', '10'],
        ['color', this.chartColor]
      ]
    }
  },
  computed: {
    computeCardDark() {
      return this.cardColor !== 'white'
    },
    computeChartOption() {
      let options = this.defaultOption.slice()
      switch (this.type) {
        case 'bar':
          options.push(['series[0].type', 'bar'])
          options.push(['series[0].barWidth', '50%'])
          options.push(['xAxis', { type: 'category', data: _.map(this.data, 'category') }])
          options.push(['yAxis', { type: 'value' }])
          options.push(['series', [{ type: 'bar', data: _.map(this.data, 'value') }]])
          break
        case 'line':
          options.push(['series[0].type', 'line'])
          options.push(['series[0].barWidth', '50%'])
          options.push(['xAxis', { type: 'category', data: _.map(this.data, 'category') }])
          options.push(['yAxis', { type: 'value' }])
          options.push(['series', [{ type: 'line', data: _.map(this.data, 'value') }]])
          // options.push(['series[0].type', 'line'])
          // options.push(['series[0].barWidth', '50%'])
          // options.push(['xAxis', { type: 'category', data: _.map(this.data, 'category') }])
          // options.push(['yAxis', { type: 'value' }])
          // options.push(['series', [{ type: 'line', data: _.map(this.data, 'value') }]])
          break
        case 'horizontal-bar':
          options.push(['series[0].type', 'bar'])
          options.push(['series[0].barWidth', '50%'])
          options.push(['xAxis', { type: 'value' }])
          options.push(['yAxis', { type: 'category', data: _.map(this.data, 'category') }])
          options.push(['series', [{ type: 'bar', data: _.map(this.data, 'value') }]])
          break
        case 'pie':
          options.push(['legend.y', 'bottom'])
          options.push(['legend.orient', 'horizontal'])
          options.push(['series[0].type', 'pie'])
          break
        case 'area':
          options.push(['yAxis', { type: 'value' }])
          options.push(['xAxis', { type: 'category', data: _.map(this.data, 'category') }])
          options.push(['series[0].type', 'line'])
          options.push(['series[0].smooth', true])
          options.push(['xAxis.boundaryGap', false])
          options.push(['series[0].areaStyle', {}])
          if (this.gradient) {
            options.push([
              'series[0].areaStyle',
              {
                normal: {
                  color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: this.chartColor[0]
                    },
                    {
                      offset: 1,
                      color: this.chartColor[1]
                    }
                  ])
                }
              }
            ])
          }
          break
        default:
          // line
          options.push(['series[0].smooth', true])
          options.push(['xAxis.boundaryGap', false])
          break
      }
      return options
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
